var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"24","fill":"#fff","key":0}),React.createElement("circle",{"cx":"24","cy":"24","r":"23.5","stroke":"#1A1A1A","strokeOpacity":".1","key":1}),React.createElement("rect",{"x":"12.706","y":"22.588","width":"22.588","height":"2.824","rx":"1","fill":"#1565D8","key":2}),React.createElement("rect",{"x":"12.706","y":"14.118","width":"15.529","height":"2.824","rx":"1","fill":"#1565D8","fillOpacity":".5","key":3}),React.createElement("rect",{"x":"19.765","y":"31.059","width":"15.529","height":"2.824","rx":"1","fill":"#1565D8","fillOpacity":".5","key":4})]);
}

MenuInline.defaultProps = {"viewBox":"0 0 48 48","width":"48","height":"48","fill":"none"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
